import Rule, {IRuleObj} from "./Rule";


export default class ImageSettingsRules extends Rule {
    static output_type = 'ozonOutputImage'

    constructor(rule: IRuleObj) {
        super(rule);
        if (rule.children_rules) {
            for (const childRule of rule.children_rules) {
                this._child_rules.push(new Rule(childRule))
            }
        }
    }

    // private _child_rules: Rule[] = []
    //
    // get child_rules(): Rule[] {
    //     return this._child_rules;
    // }


}